$(document).ready(function() {
  if ($(".announcement-bar__close-button").length > 0) {
    let close_btns = $(".announcement-bar__close-button");
    
    close_btns.each((index, close_btn) => {
      let parent_section = $(close_btn).closest(".section-announcement");

      $(close_btn).on("click", () => {
        parent_section.hide();
        document.body.classList.add("announcement-hide");
        $('.header').css('margin-top', '0px');
        // Nas coleções, remove o padding do main quando fecha o announcement
        if ($('body').hasClass('template-collection') && 
            !$('body').hasClass('template-collection-toda-a-loja')) {
          $('#MainContent').css('padding-top', '0px');
        }
      });
    });
  }

  // Reaplica margin-top do announcement quando volta ao topo (coleções)
  if ($('body').hasClass('template-collection') && 
      !$('body').hasClass('template-collection-toda-a-loja')) {
    
    var $header = $('.header');
    var $announcement = $('.section-announcement-bar');
    
    if ($header.length && $announcement.length) {
      $(window).on('scroll', function() {
        if ($(window).scrollTop() <= 10) {
          $header.css('margin-top', $announcement.outerHeight() + 'px');
          $('#MainContent').css('padding-top', $announcement.outerHeight() + 'px');
        } else {
          $header.css('margin-top', '0px');
          $('#MainContent').css('padding-top', '0px');
        }
      });
      
      // Aplica no load também
      $header.css('margin-top', $announcement.outerHeight() + 'px');
      $('#MainContent').css('padding-top', $announcement.outerHeight() + 'px');
    }
  }
});
